// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2c796e83" + "." + "8cc64102bd73e419" + ".js";
};